import i18n from 'modules/core/lib/i18n'

export const TABS_IDS = {
  participation: 'participation',
  answers: 'answers',
  heatmap: 'heatmap',
  analytics: 'analytics',
  team: 'team',
  employee_scores: 'employee_scores',
}

export const buildTabs = (showTeamInsights: boolean, showEmployeeScores: boolean) => {
  const tabs: { active: boolean; id: string; label: string }[] = [
    {
      active: true,
      id: TABS_IDS.participation,
      label: i18n.t('performance_process.overview.results.participants_tab'),
    },
    {
      active: false,
      id: TABS_IDS.answers,
      label: i18n.t('performance_process.overview.results.answers_tab'),
    },
    {
      active: false,
      id: TABS_IDS.heatmap,
      label: i18n.t('performance_process.overview.results.heatmap_tab'),
    },
  ]

  if (showEmployeeScores) {
    tabs.push({
      active: false,
      id: TABS_IDS.employee_scores,
      label: i18n.t('performance_process.overview.results.scores_tab'),
    })
  } else {
    tabs.push({
      active: false,
      id: TABS_IDS.analytics,
      label: i18n.t('performance_process.overview.results.analytics_tab'),
    })
  }

  if (showTeamInsights) {
    tabs.push({
      active: false,
      id: TABS_IDS.team,
      label: i18n.t('performance_process.overview.results.team_insights_title'),
    })
  }

  return tabs
}
